import { style } from '@/styles/globals';
import { pr } from '@/utils/pxToRem';
import { Stack, Typography } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';
import { styled } from '@mui/system';

interface SeoNoteProps {
  listNote: string[];
}

const Container = styled(Box)`
  background: ${style.color.blue4};
  padding: ${pr`12px`};
  border: 0.5px solid #d0e9fb;
  box-sizing: border-box;
  border-radius: 6px;
`;

const SeoNote: React.FC<SeoNoteProps> = ({ listNote }) => (
  <Container>
    <Stack spacing={pr`4px`}>
      <Typography
        variant="contentBold"
        color={style.color.blue2}
      >
        Lưu ý
      </Typography>
      {listNote.map((note) => (
        <Typography
          key={note}
          sx={{
            position: 'relative',
            marginLeft: '1.5em !important',
            '::before': {
              content: '""',
              width: 7,
              height: 7,
              background: style.color.blue2,
              borderRadius: '50%',
              position: 'absolute',
              left: -16,
              top: 6,
            },
            fontWeight: 400,
          }}
          color={style.color.blue2}
        >
          {note}
        </Typography>
      ))}
    </Stack>
  </Container>
);

export default SeoNote;
